<!--贴心服务-广告配置-->
<template>
  <section>
    <!-- 工具条 -->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="AdvenrtStatus" size="mini">
        <el-form-item>
          <el-select
            v-model="AdvenrtStatus.shows"
            placeholder="上架状态"
            clearable
            @keyup.native.enter="handleFilterChange"
            @change="handleFilterChange"
          >
            <el-option value="1" label="是"/>
            <el-option value="2" label="否"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            @change="handleFilterChange"
            size="mini"
            v-model.trim="AdvenrtStatus.name"
            placeholder="搜索内容"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleFilterChange"
            ></el-button
            >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="AdvenrtStatus.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00','23:59:59']"
            @change="handleFilterChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!-- 列表 -->
    <el-col :span="24">
      <el-table
        :data="datalist.content"
        size="mini"
        border
        highlight-current-row
        v-loading="loading"
        :max-height="clientHeight"
        style="width: 100%"
        :header-cell-style="headerCellStyle"
      >
        <el-table-column type="index" label="序号" align="center" width="55"/>
        <el-table-column
          prop="title"
          label="标题"
          width="140"
          align="center"
          show-overflow-tooltip
          header-align="center">
        </el-table-column>
        <el-table-column
          prop="image"
          label="主图"
          width="140"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="demo-image__preview">
              <el-image style="width: 40px;height: auto;"
                :src=scope.row.image
                :preview-src-list="[scope.row.image]"
                >
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="tag"
          label="访问链接"
          width="180"
          show-overflow-tooltip
          header-align="center"
          align="center"
        />
        <el-table-column
          prop="create_at"
          width="160"
          label="上传时间"
          sortable
          align="center"
          header-align="center"
        />
        <el-table-column
          prop="name"
          width="100"
          label="上传人"
          align="center"
          header-align="center"
        />
        <el-table-column
          prop="level_name"
          width="100"
          label="广告层级"
          align="center"
          header-align="center"
        />
        <el-table-column
          prop="shows"
          label="上架状态"
          sortable
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.shows === 1">上架</span>
            <span v-else>下架</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="审核状态"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">待审核</span>
            <span v-else-if="scope.row.status === 1 ">审核通过</span>
            <span v-else-if="scope.row.status === 2 ">未通过审核</span>
            <span v-else>-</span>
          </template>
        </el-table-column>


          <el-table-column align="center" width="auto" header-align="center" label="操作">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: space-evenly">
                  <template v-if="scope.row.type == 2"> <el-link :href="scope.row.tag" type="primary" target="_blank" :disabled="false" rel="noopener noreferrer" style="font-size: 12px;margin-right: 8px;color: #409EFF">预览</el-link></template>
                  <template v-else><el-button type="text" style="color: #409EFF" size="mini" @click="handleView(scope.row)">预览</el-button></template>
                  <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                  <el-button type="text" size="mini" style="color: red;" @click="handleDel(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            width="100"
            align="center"
            header-align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.shows === 1">
                <el-button type="danger" size="mini" @click="handleOnlian(scope.row, 2)">下架</el-button>
              </div>
              <div v-else>
                <el-button type="primary" size="mini" @click="handleOnlian(scope.row, 1)">上架</el-button>
              </div>
            </template>
          </el-table-column>
        <el-table-column
          label="审核"
          align="center"
          width="120"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              :type="scope.row.status ===0? 'primary':'info'"
              :disabled="scope.row.status !==0"
              @click="handleVerify(scope.row)">
              审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>

    <!-- 工具条 -->
    <el-col :span="24" class="toolbar">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="AdvenrtStatus.page"
        :page-sizes="AdvenrtStatus.pageSizes"
        layout="total, sizes, prev, pager, next, jumper"
        :total="datalist.total"
        style="display: inline-block; margin-left: 15px;margin-top:12px;"
      >
      </el-pagination>
    </el-col>


    <!--新增、编辑界面-->
    <el-dialog
      :title="AdvenrtDialog.title"
      :visible.sync="AdvenrtDialog.visible"
      @close="handlerClose"
      top="100px"
    >
      <div>
        <el-form
          :model="AdvenrtDialogData"
          label-width="140px"
          :rules="AdvenrtRule"
          ref="form"
          size="mini"
        >
          <el-form-item prop="title" label="标题">
              <el-input
                placeholder="请输入内容"
                v-model="AdvenrtDialogData.title">
              </el-input>
          </el-form-item>
          <el-form-item label="主图" prop="image" style="position: relative;height: auto">
              <div>
                <el-upload
                  ref="upload"
                  accept=".jpg, .jpeg, .png"
                  list-type="picture-card"
                  :action="upload()"
                  :on-success="handleAvatarSuccess"
                  :file-list="fileList"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :on-remove="handleRemove"
                >
                  <i class="el-icon-plus"/>
                  <div slot="tip">上传照片（最多1张，支持jpg、jpeg、png）照片尺寸：长宽2：7</div>
                </el-upload>
              </div>
          </el-form-item>

          <el-form-item prop="type" label="类型">
            <el-select :disabled="AdvenrtDialog.title === '编辑'" v-model="AdvenrtDialogData.type" style="width: 100%" @change="changeAdvenrtType">
              <el-option
                label="文章"
                :value="1"
              ></el-option>
              <el-option
                label="链接"
                :value="2"
              ></el-option>
            </el-select>
          </el-form-item>


          <el-form-item prop="tag" label="访问链接">
            <template v-if="AdvenrtDialogData.type === 1">
            <el-select v-model="AdvenrtDialogData.tag" placeholder="请选择访问链接"  style="width: 100%">
              <el-option
                v-for="item in AdvenrtRULData"
                :key="item.id"
                :label="item.title"
                :value="item.id.toString()">
              </el-option>
            </el-select>
            </template>
            <template v-else>
              <el-input
                placeholder="请输入访问链接"
                v-model="AdvenrtDialogData.tag">
              </el-input>
            </template>
          </el-form-item>
          <el-form-item prop="level" label="广告层级">
            <el-select v-model="AdvenrtDialogData.level" style="width: 100%">
              <el-option
                label="一级"
                :value="1"
              ></el-option>
              <el-option
                label="二级"
                :value="2"
              ></el-option>
              <el-option
                label="三级"
                :value="3"
              ></el-option>
              <el-option
                label="四级"
                :value="4"
              ></el-option>
              <el-option
                label="五级"
                :value="5"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="owners" label="应用单位">
            <el-cascader
              style="width: 100%"
              placeholder="请选择应用账号所属单位"
              v-model="AdvenrtDialogData.owners"
              :options="options"
              :props="AdvenrtProps"
              ref="test"
              collapse-tags
              filterable
              clearable
              @change="handleChange()"
              filterable
            />
          </el-form-item>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="AdvenrtDialog.visible = false"
        >取消</el-button
        >
        <el-button type="primary" size="mini" @click.native="handleSubmit"
        >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="广告内容" :visible.sync="dialogTableVisible">
      <div style="margin:20px;" v-html="html"></div>
    </el-dialog>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import {dateFormater,} from '@/util/index'

import {
  loadData,
  getUserInfo
} from '@/util/index'
import conf from "@/config";

export default {
  name: 'AdvertConfig',

  data() {
    return {
      html: null,
      dialogTableVisible: false,
      AdvenrtRULData: [],
      uploadOwner:[],//发送请求用到的应用单位
      srcList:[],//大图预览照片的数组
      AdvenrtProps:{ multiple: true,checkStrictly: false,},//设置应用单位可以多选
      options: [],//应用单位下拉框的数据
      loading: false,
      datalist: {},//请求的广告的数据
      userInfo: {},
      org: null,
      dialogImageUrl:'',//预览图片的url
      fileList: [],//用于管理上传文件列表
      changeStatus: false,
      AdvenrtDialogData:{//广告弹窗选择的数据
        title: '',
        image: '',
        tag: '',
        level: 1, // 保留默认值
        owners: [],
        type: 1,
      },
      AdvenrtRule: {//广告弹窗的验证规则
        title: [{required: true, message: '广告标题不可为空', trigger: 'blur'}],
        image: [{required: true, message: '广告主图不可为空', trigger: 'blur'}],
        level: [{required: true, message: '广告层级不可为空', trigger: 'blur'}],
        owners: [{required: true, message: '应用单位不可为空', trigger: 'blur'}],
      },
      AdvenrtDialog: {//广告弹窗
        title:'',//广告弹窗的标题
        visible: false,//是否显示弹窗
      },
      AdvenrtStatus: {//筛选的广告状态
        name: null,
        shows: null,
        dateRange: null,
        page: 1,
        size: 20,
        pageSizes: [20, 30, 50]
      },
    }
  },
  computed: {
    ...mapState(['areaTree', 'clientHeight', 'customerTree', 'customer']),
    ...mapState({
      props: (state) => Object.assign({}, state.props, {label: 'Org'}),
      customerProps: (state) =>
        Object.assign({}, state.props, {label: 'Org', checkStrictly: false, multiple: true,}),
      selAreaProps: (state) =>
        Object.assign({}, state.props, {checkStrictly: true}),
      areaProps: (state) => Object.assign({}, state.props)
    })
  },
  async mounted() {
    const resultTree = this.convertCustomerTree(this.customerTree);
    this.options = resultTree
    try {
      const user = getUserInfo()
      this.userInfo = user.Info
    } catch (e) {
      this.$message.error(e)
    }
    if (this.customerTree.length === 0) {
      loadData(this, null, 1)
    }
    this.getData()
  },
  methods: {
    // 广告类型切换时，清空广告链接
    changeAdvenrtType(){
      this.AdvenrtDialogData.tag = ''
    },
    async getArticle(){
      this.$get('admin/plat_message', {type:2}).then(res => {
        this.AdvenrtRULData = res.list
      })
    },
    //剔除掉所属单位多余字段
    convertCustomerTree(treeData) {
      const convertNode = (node) => {
        const converted = {
          value: node.Id,
          label: node.Org || '',
        };
        // 递归处理子节点
        if (node.children && Array.isArray(node.children) && node.children.length > 0) {
          converted.children = node.children.map(convertNode);
        }
        return converted;
      };
      return treeData
        .filter(node => node.Id !== undefined && node.Id !== null)
        .map(convertNode);
    },
    //转换级联选择器的数据
    handleChange() {
      let checkedNodeList = this.$refs.test.getCheckedNodes();
      checkedNodeList = checkedNodeList.filter(item => !(item.parent && item.parent.checked));
      // 转换格式用于给后端数据
      const pathList = checkedNodeList.map(node =>
        `/${node.path.join('/')}/` // 用模板字符串拼接首尾斜杠
      );
      this.uploadOwner = pathList
      this.changeStatus = true
    },

    //合并单元格
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      // 隐去第10列单元格
      if (columnIndex == 10) {
        return { display: "none" };
      }
      // 第二步，让第9列单元格横跨两列（默认单元格只是横跨一列）
      if ((rowIndex == 0) & (columnIndex == 9)) {
        this.$nextTick(() => {
          document.querySelector(`.${column.id}`).setAttribute("colspan", "2");
        });
      }
    },

    //添加限制最多一张照片
    handleExceed() {
      this.$message.warning(`照片数量限制在1张`)
    },
    //移除上传的图片
    handleRemove(file, fileList) {
      console.log('要删除图片',  file,  fileList)
      this.fileList = []
    },
    //图片上传完成时调用
    handleAvatarSuccess(res, file) {
      this.AdvenrtDialogData.image = res.Data;
      this.fileList = [{
        url: res.Data
      }];
    },
    //上传主图照片
    upload() {
      return conf.uploadApi + '/uploadToOss'
    },
    // 下载图片
    download(name, imgData) {
      this.downloadFile(name, imgData)
    },
    // 新增方法：处理筛选条件变化
    handleFilterChange() {
      // 筛选条件变化时，重置页码到第一页
      this.AdvenrtStatus.page = 1;
      this.getData();
    },
    getData() {
      this.loading = true
      const param = {
        page: this.AdvenrtStatus.page,
        size: this.AdvenrtStatus.size,
      }
      if (this.AdvenrtStatus.shows) {
        param.shows = this.AdvenrtStatus.shows
      }
      if (this.AdvenrtStatus.name) {
        param.name = this.AdvenrtStatus.name
      }
      if (this.AdvenrtStatus.dateRange) {
        param.start_time = this.AdvenrtStatus.dateRange[0].getTime() / 1000
        param.end_time = this.AdvenrtStatus.dateRange[1].getTime() / 1000
      }
      this.$get("admin/advertisement", param).then(res => {
        this.datalist.content = res.list
        this.datalist.total = res.count
        this.loading = false
      })
    },
    dateFormat(r, c) {
      return dateFormater(r[c.property], true)
    },

    //审核
    handleVerify(row){
      const { id, title } = row
      this.$confirm(`确认是否审核通过【${title}】，通过后即在移动端展示。`, '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: '不通过'
      })
      .then(() => {
        let formData = new URLSearchParams()
        formData.append('status', 1)
        this.$post('admin/advertisement/check/' + row.id,formData).then(res => {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          setTimeout(()=> {
            this.getData()
          }, 500)
        })
      })
      .catch(action => {
        let formData = new URLSearchParams()
        formData.append('status', 2)
        this.$post('admin/advertisement/check/' + row.id,formData).then(res => {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          setTimeout(()=> {
            this.getData()
          }, 500)
        })
      });
    },

    // 改变页容量
    handleSizeChange(size) {
      this.AdvenrtStatus.size = size
      this.getData()
    },
    // 翻页
    handleCurrentChange(page) {
      this.AdvenrtStatus.page = page
      this.getData()
    },
    //弹窗关闭
    handlerClose: function() {
      this.fileList = []
      this.AdvenrtDialogData = {
        title: '',
        image: '',
        tag: '',
        type:1,
        level: 1, // 保留默认值
        owners: []
      };
    },
    //新增广告
    async handleAdd() {
      this.uploadOwner = []
      this.AdvenrtDialog.title = '新增'
      this.AdvenrtDialog.visible = true
      this.getArticle()
    },




    parsePathString(pathStr) {
      return pathStr
        .replace(/^\/+|\/+$/g, '')
        .split('/')
        .filter(p => p !== '')
        .map(Number);
    },

    findNodeAndPath(options, pathArray) {
      let currentPath = [];
      let currentNode = null;
      let children = options;

      for (const val of pathArray) {
        const node = children.find(n => n.value === val);
        if (!node) {
          return { node: null, path: null };
        }
        currentPath.push(val);
        currentNode = node;
        children = node.children || [];
      }

      return { node: currentNode, path: currentPath };
    },

    collectLeafPathsFromNode(node, basePath) {
      const result = [];

      function traverse(currentNode, currentPath) {
        const newPath = [...currentPath, currentNode.value];
        if (!currentNode.children || currentNode.children.length === 0) {
          result.push(newPath);
        } else {
          currentNode.children.forEach(child => {
            traverse(child, newPath);
          });
        }
      }

      traverse(node, basePath);
      return result;
    },

    generateResult(options, backendPaths) {
      const result = [];
      for (const pathStr of backendPaths) {
        const pathArray = this.parsePathString(pathStr);
        const { node, path } = this.findNodeAndPath(options, pathArray);
        if (!node || !path) {
          continue;
        }
        const basePath = path.slice(0, -1);
        const leafPaths = this.collectLeafPathsFromNode(node, basePath);
        result.push(...leafPaths);
      }
      return result;
    },
    //编辑广告
    async handleEdit(row) {
      this.uploadOwner = []
      this.changeStatus = false
      this.AdvenrtDialog.title = '编辑'
      this.AdvenrtDialog.visible = true
      await this.getArticle()
      this.$get("admin/advertisement/info/" + row.id, {}).then(res => {
        this.AdvenrtDialogData = res
        const backendData = res.owners;
        //回显之前选择的归属单位
        const result = this.generateResult(this.options, backendData);
        this.AdvenrtDialogData.owners = result
      })
      this.fileList = [{
        url: row.image
      }];
    },

    async handleView(row) {
      this.$get("admin/advertisement/info/" + row.id, {}).then(res => {
        this.html = res.plat_message.content
        this.dialogTableVisible = true
      })
    },

    //删除广告
    handleDel(row) {
      const { id, title } = row
      this.$confirm(`您正在删除【${title}】,是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        this.$post('admin/advertisement/delete/' + row.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          setTimeout(()=> {
            this.getData()
          }, 500)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    //上架广告
    handleOnlian(row, shows){
      const { id, title } = row
      var anction = "下架"
      if (shows == 1) {
        anction = "上架"
      }
      this.$confirm(`您正在${anction}【${title}】,是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        let formData = new URLSearchParams()
        formData.append('shows', shows)
        this.$post('admin/advertisement/update/' + row.id,formData).then(res => {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          setTimeout(()=> {
            this.getData()
          }, 500)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    //  提交广告配置
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '数据请求中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          if (this.AdvenrtDialog.title === '新增') {
            let formData = new URLSearchParams()
            formData.append('title', this.AdvenrtDialogData.title)
            formData.append("type", this.AdvenrtDialogData.type)
            formData.append("image", this.AdvenrtDialogData.image)
            formData.append("level", this.AdvenrtDialogData.level)
            formData.append("tag", this.AdvenrtDialogData.tag)
            formData.append("owners", this.uploadOwner.join(","))
            this.$post('admin/advertisement/add', formData).then(res => {
              this.$message.success('添加成功')
              this.AdvenrtDialog.visible = false
              setTimeout(()=> {
                this.getData()
              }, 800)
            })
            loading.close()
          } else if (this.AdvenrtDialog.title === '编辑') {
            let formData = new URLSearchParams()
            formData.append('title', this.AdvenrtDialogData.title)
            formData.append("type", this.AdvenrtDialogData.type)
            formData.append("image", this.AdvenrtDialogData.image)
            formData.append("level", this.AdvenrtDialogData.level)
            formData.append("tag", this.AdvenrtDialogData.tag)
            if (this.changeStatus) {
              formData.append("owners", this.uploadOwner.join(","))
            }
            this.$post('admin/advertisement/edit/' + this.AdvenrtDialogData.id, formData).then(res => {
              this.$message.success('编辑成功')
              this.AdvenrtDialog.visible = false
              setTimeout(()=> {
                this.getData()
              }, 800)
            })
            loading.close()
          } else {
            loading.close()
            return false
          }
        } else {
          return false
        }
      })
    },

  }
}
</script>

<style lang="scss" scoped>

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}

.single-img > img {
  width: 160px;
  height: 160px;
}

.view-img {
  width: 178px;
  height: 178px;
  margin-right: 10px;
}

.remove-img {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  color: #FFF;
  text-align: center;
  background: rgba(0, 0, 0, .5);
  transition: transform .3s;
  -webkit-transition: transform .3s;
}

.remove-img:hover {
  cursor: pointer;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
}

.locale-progress {
  margin-top: 12px;
  margin-right: 40px;
}

.el-divider--vertical{
  height: 4em !important;
}

</style>
